const ADD_COMPANY = 'ADD_COMPANY'
const UPDATE_COMPANY = 'UPDATE_COMPANY'
const DELETE_COMPANY = 'DELETE_COMPANY'

const ADDRESS_FETCH = 'ADDRESS_FETCH'
const ADDRESS_CREATE = 'ADDRESS_CREATE'
const ADDRESS_DELETE = 'ADDRESS_DELETE'
const ADDRESS_UPDATE = 'ADDRESS_UPDATE'

export {ADD_COMPANY, UPDATE_COMPANY, DELETE_COMPANY,
  ADDRESS_FETCH, ADDRESS_CREATE, ADDRESS_DELETE, ADDRESS_UPDATE}